module.exports = __webpack_public_path__ + "static/media/checkbox.af1703a0.svg";